<div class="container_sections">
  <div class="items">
    <img ngSrc="../assets/img/category_artoyz_website.webp" class="d-none d-md-block" alt="Art Toys" width="338" height="600" eager />
    <img ngSrc="../assets/img/category_artoyz_mobile.webp" class="d-md-none" alt="Art Toys" width="169" height="300" eager />
    <div class="container_button_category">
      <p class="h4">Art Toy</p>

      <a [routerLink]="['/category', 'artoys']" class="btn btn__default--blank"> Ver productos</a>
    </div>
  </div>
  <div class="items">
    <img ngSrc="../assets/img/category_sofubi_website.webp" class="d-none d-md-block" alt="Sofubi" width="338" height="600" eager />
    <img ngSrc="../assets/img/category_sofubi_mobile.webp" class="d-md-none" alt="Sofubi" width="169" height="300" eager />
    <div class="container_button_category">
      <p class="h4">Sofubi</p>
      <a [routerLink]="['/category', 'sofubi']" class="btn btn__default--blank"> Ver productos</a>
    </div>
  </div>
  <div class="items">
    <img ngSrc="../assets/img/category_gachapon_website.webp" class="d-none d-md-block" alt="Gachapon" width="338" height="600" eager />
    <img ngSrc="../assets/img/category_gachapon_mobile.webp" class="d-md-none" alt="Gachapon" width="169" height="300" eager />
    <div class="container_button_category">
      <p class="h4">Gachapon</p>
      <a [routerLink]="['/category', 'gachapon']" class="btn btn__default--blank"> Ver productos</a>
    </div>
  </div>
  <div class="items">
    <img ngSrc="../assets/img/category_blindbox_website.webp" class="d-none d-md-block" alt="Blindbox" width="338" height="600" eager />
    <img ngSrc="../assets/img/category_blindbox_mobile.webp" class="d-md-none" alt="Blindbox" width="169" height="300" eager />
    <div class="container_button_category">
      <p class="h4">Blindbox</p>
      <a [routerLink]="['/category', 'blindbox']" class="btn btn__default--blank"> Ver productos</a>
    </div>
  </div>
</div>
